/* eslint-disable import/no-named-as-default */
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vue from 'vue'

Vue.component('Multiselect', Multiselect)
